import { styled } from 'styled-components';

import { bodyMicroText, colors, spacing } from '#/theme/theme';

export const SearchImportedHitInfoSourceHolder = styled.div`
  ${bodyMicroText};
  line-height: 1;
  color: ${colors.lightContentGrey};

  &:not(:last-child) {
    margin-bottom: ${spacing[8]};
  }
`;

export const SearchImportedHitInfoLabels = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
  gap: ${spacing[8]};
  margin: 15px 0 10px;
`;
